import { toast } from 'react-toastify'
import { create } from 'zustand'

import { useUserStore } from '../../user/stores/user.store'
import { projectApi } from '../api/project.api'
import { CreateProjectDto, Project } from '../types/project.types'

export interface ProjectStore {
  project: Project | null
  projects: Project[]
  isLoaded: boolean
  loadProjects: () => Promise<void>
  setProject: (project: Project) => void
  saveProject: (data: CreateProjectDto) => void
}

export const useProjectStore = create<ProjectStore>((set) => ({
  project: null,
  projects: [],
  isLoaded: false,
  loadProjects: async () => {
    set((state) => ({ ...state, isLoaded: false }))

    const projects = await projectApi.list()
    const user = useUserStore.getState().user

    // TODO Сделать релейшн users <-> project чтобы показывать пользователю только те проекты, на которые он назначен

    return set((state) => ({ ...state, projects, isLoaded: true, project: projects.find((project) => user?.projectId === project.id) }))
  },
  saveProject: async (project: CreateProjectDto) => {
    try {
      const savedProject = await projectApi.create(project)

      return set((state) => ({ ...state, projects: [...state.projects, savedProject] }))
    } catch {
      toast.error('Невозможно создать проект')
    }
  },
  setProject: async (project) => set({ project }),
}))
